import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import './DownloadImage.css';
// import html2canvas from 'html2canvas';
// import ImageRenderer from './ImageRenderer';
// import axios from 'axios';
// import config from '../../config';
import { AuthContext } from '../../context/AuthContext';

const DownloadImage = ({ templateIndex, setErr }) => {
    const { user, fetchShareImagesFromDB } = useContext(AuthContext);

    const handleDownloadClick = async (e) => {
        e.stopPropagation();
        try {
            console.log('downloading image now...');
            const imgSrc = await getCachedUrls(user.username, templateIndex);
            if(typeof imgSrc !== 'string'){
                throw new Error("Image source is not a string");
            }
            // Extract the base64 part from the data URL
            const base64Data = imgSrc.split(',')[1];
                    
            // Decode base64 to Uint8Array
            const binaryString = window.atob(base64Data);
            const len = binaryString.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }

            // Create Blob from Uint8Array
            const mimeString = imgSrc.split(',')[0].split(':')[1].split(';')[0];
            const blob = new Blob([bytes], { type: mimeString });
            const file = new File([blob], "image.png", { type: "image/png" });

            const shareData = {
              files: [file],
              title: "Wishlist Image",
              text: "Here's an image from my wishlist",
            };
            if (navigator.canShare && navigator.canShare(shareData)) {
                await navigator.share(shareData);
            } else {
                setErr("navigator.canShare not met.");
            }
        } catch (error) {
            // let shareErr = stringifyError(error);
            // setErr(shareErr);
            console.error("Error sharing the image:", error);
        }
    };

    const getCachedUrls = async (username, templateIndex) => {
        try {
          const images = await fetchShareImagesFromDB(username, templateIndex);
          if (images === null) {
            throw new Error("No image found at the given index");
          }
          return images;
        } catch (error) {
          console.error("Error in getCachedUrls:", error);
          throw error;
        }
      };


    return (
        <div className='downloadImage'>
            <button type="button" id="download-img-btn" onClick={handleDownloadClick}>Download</button>
        </div>
        
    );
};

export default DownloadImage

DownloadImage.propTypes = {
    downloadFunction: PropTypes.bool,
    templateIndex: PropTypes.number,
    setErr: PropTypes.func,
    details: PropTypes.shape({
        type: PropTypes.string,
        title: PropTypes.string,
        amount: PropTypes.number,
        giveorreceive: PropTypes.string,
        remainingQuantity: PropTypes.number,
        initialQuantity: PropTypes.number,
        photo: PropTypes.string,
        wishlistItems: PropTypes.array,
        username: PropTypes.string,
      }),
};